'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (lang, locale) {
  if (_salesPhoneNumbers2.default[locale]) {
    var countryCode = (0, _getCountryCodeFromLocale2.default)(locale).toUpperCase();
    return _salesPhoneNumbers2.default[locale][lang] ? { phoneNumber: _salesPhoneNumbers2.default[locale][lang], countryCode: countryCode } : { phoneNumber: _salesPhoneNumbers2.default[locale].en, countryCode: countryCode };
  }

  return { phoneNumber: _salesPhoneNumbers2.default.DEFAULT, countryCode: 'US' };
};

var _getCountryCodeFromLocale = require('./getCountryCodeFromLocale');

var _getCountryCodeFromLocale2 = _interopRequireDefault(_getCountryCodeFromLocale);

var _salesPhoneNumbers = require('ui-addon-upgrades/_core/common/constants/salesPhoneNumbers');

var _salesPhoneNumbers2 = _interopRequireDefault(_salesPhoneNumbers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/adapters/getSalesPhoneNumber.js
// module id = 567
// module chunks = 3 4 5